"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../../types");
var services_1 = require("../../services");
var INNER_ROUTES = [
    types_1.App.Routes.MATCH,
    types_1.App.Routes.OUTRIGHT,
    types_1.App.Routes.TOURNAMENT,
    types_1.App.Routes.RESULT_MATCH,
    types_1.App.Routes.AFTERMATCH,
];
var isInnerPage = function (pathname, excludedInnerPages) {
    if (pathname === void 0) { pathname = services_1.getHistory().location.pathname; }
    var routesToCheck = (excludedInnerPages === null || excludedInnerPages === void 0 ? void 0 : excludedInnerPages.length)
        ? INNER_ROUTES.filter(function (r) { return !excludedInnerPages.includes(r); })
        : INNER_ROUTES;
    return routesToCheck.some(function (route) { return pathname.includes(route); });
};
exports.default = isInnerPage;
//# sourceMappingURL=isInnerPage.js.map